/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_uc_area_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`About 10.764 square feet. This comes from squaring the foot-to-meter ratio (1 foot = 0.3048 m, and 0.3048² ≈ 0.0929, so 1 ÷ 0.0929 ≈ 10.764). It's a bigger jump than people expect from the linear 3.28 ft-per-meter ratio, since area scales by the square.`)
};

const es_uc_area_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aproximadamente 10.764 pies cuadrados. Esto viene de elevar al cuadrado la razón pie-a-metro (1 pie = 0.3048 m, y 0.3048² ≈ 0.0929, así que 1 ÷ 0.0929 ≈ 10.764). Es un salto más grande que la gente espera de la razón lineal 3.28 pies-por-metro, porque el área se escala por el cuadrado.`)
};

const de_uc_area_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etwa 10.764 Quadratfuß. Das ergibt sich durch Quadrieren des Fuß-zu-Meter-Verhältnisses (1 Fuß = 0.3048 m, und 0.3048² ≈ 0.0929, also 1 ÷ 0.0929 ≈ 10.764). Das ist ein größerer Sprung, als man vom linearen Verhältnis von 3.28 ft pro Meter erwarten würde, da Fläche quadratisch skaliert.`)
};

const nl_uc_area_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ongeveer 10.764 vierkante voet. Dit komt van het kwadrateren van de voet-naar-meter verhouding (1 voet = 0.3048 m, en 0.3048² ≈ 0.0929, dus 1 ÷ 0.0929 ≈ 10.764). Het is een grotere sprong dan mensen verwachten van de lineaire 3.28 ft-per-meter verhouding, omdat oppervlakte schaal door het vierkant.`)
};

const fr_uc_area_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Environ 10,764 pieds carrés. Cela vient de la mise au carré du rapport pied-mètre (1 pied = 0,3048 m, et 0,3048² ≈ 0,0929, donc 1 ÷ 0,0929 ≈ 10,764). C'est un plus grand saut que ce que les gens attendaient du rapport linéaire de 3,28 pi par mètre, car la superficie se redimensionne par le carré.`)
};

const it_uc_area_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Circa 10,764 piedi quadrati. Questo proviene dal quadrato del rapporto piede-metro (1 piede = 0,3048 m, e 0,3048² ≈ 0,0929, quindi 1 ÷ 0,0929 ≈ 10,764). È un balzo più grande rispetto al rapporto lineare di 3,28 piedi per metro che le persone si aspettano, poiché l'area scala al quadrato.`)
};

const pt_br2_uc_area_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerca de 10.764 pés quadrados. Isto vem de elevar ao quadrado a proporção pé-para-metro (1 pé = 0.3048 m, e 0.3048² ≈ 0.0929, então 1 ÷ 0.0929 ≈ 10.764). É um salto maior do que as pessoas esperam da proporção linear 3.28 ft-por-metro, já que a área se escala pelo quadrado.`)
};

const pt_uc_area_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerca de 10,764 pés quadrados. Isto vem da elevação ao quadrado da razão pé-para-metro (1 pé = 0,3048 m, e 0,3048² ≈ 0,0929, portanto 1 ÷ 0,0929 ≈ 10,764). É um salto maior do que as pessoas esperam da razão linear 3,28 ft-por-metro, porque a área escala pelo quadrado.`)
};

const ja_uc_area_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`約10.764平方フィート。これは、フィートからメートルへの比率を二乗することから来ています(1フィート = 0.3048 m、0.3048² ≈ 0.0929、1 ÷ 0.0929 ≈ 10.764)。線形の3.28 ft-per-メートルの比率からの人々が期待するより大きなジャンプです。面積は平方でスケーリングするため。`)
};

const zh_uc_area_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[pending translation B]`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const uc_area_faq1_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.uc_area_faq1_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("uc_area_faq1_a", locale)
	if (locale === "en") return en_uc_area_faq1_a(inputs)
	if (locale === "es") return es_uc_area_faq1_a(inputs)
	if (locale === "de") return de_uc_area_faq1_a(inputs)
	if (locale === "nl") return nl_uc_area_faq1_a(inputs)
	if (locale === "fr") return fr_uc_area_faq1_a(inputs)
	if (locale === "it") return it_uc_area_faq1_a(inputs)
	if (locale === "pt-BR") return pt_br2_uc_area_faq1_a(inputs)
	if (locale === "pt") return pt_uc_area_faq1_a(inputs)
	if (locale === "ja") return ja_uc_area_faq1_a(inputs)
	return zh_uc_area_faq1_a(inputs)
};